exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#confirmation-warning{border:1px solid #cf1b1b;border-radius:.25rem;padding:15px;color:#fff;width:75%;background:#e53838;margin-top:15px}#confirmation-warning p{font-size:13px;display:inline;margin-right:16px}#confirmation-warning input{vertical-align:text-bottom}", ""]);

// exports
